import { DocumentReference } from "@atgof-firebase/firebase";
import React from "react";
import { BreakdownTable } from "./BreakdownTable";
import { ProgressBar } from "react-native-paper";
import { useTeams } from "../data/team";
import { useScenesTableSectionForEpisode } from "./ScenesTable";
import { View } from "react-native";

export const BreakdownView = React.forwardRef<
  View,
  {
    episodeRef: DocumentReference | undefined;
  }
>(({ episodeRef }, ref) => {
  const teams = useTeams();
  const sections = useScenesTableSectionForEpisode(episodeRef, teams);
  if (!sections) return <ProgressBar indeterminate />;
  return <BreakdownTable ref={ref} sections={sections} />;
});
